import { render } from "./SearchSidebar.vue?vue&type=template&id=53328a95&ts=true"
import script from "./SearchSidebar.vue?vue&type=script&lang=ts"
export * from "./SearchSidebar.vue?vue&type=script&lang=ts"

import "./SearchSidebar.vue?vue&type=style&index=0&id=53328a95&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__